import { useMutation } from '@apollo/client'
import { DELETE_PAYEES_MUTATION } from '../../../graphql/mutation/payees/payees_delete.graphql'

export const useDeleteBillService = () => {
  const [
    loadDeleteApi,
    {
      called = true,
      loading: gqlLoading = true,
      error: gqlError = null,
      data: gqlData = null
    }
  ] = useMutation(DELETE_PAYEES_MUTATION)

  /**
   * Always use lazy graphql query react hook to make API call.
   * decide to make API call or not based on the components prop(TBD) value
   * if the prop value is boolean false make call to loadApi else skip the call
   * note: this useEffect executes only once when the component is mount.
   */
  // useEffect(() => {
  // loadApi()
  // }, [])

  /**
   * when apollo client updates gqlData, gqlLoading or gqlError
   * trigger subsquent action or data processing.
   * for example: triggering routing change or clean up data
   */

  return {
    loadDeleteApi,
    deleteCalled: called,
    deleteLoading: gqlLoading,
    deleteData: gqlData,
    deleteError: gqlError
  }
}
export default useDeleteBillService
